import React, { useState, useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TableSortLabel, Pagination } from '@mui/material';
import LoadingComponent from '../../../_commons/LoadingComponent';

function BulkDeleterModalTable({
    contentList,
    totalCount,
    page,
    isLoading,
    noData,
    onPageChange
}) {
    const tableContainerRef = useRef(null);
    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const [rowsPerPage] = useState(30);

    const cdn = useSelector(state => state.organization.cdn);

    const totalPages = Math.ceil(totalCount / rowsPerPage);

    useEffect(() => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollTop = 0;
        }
    }, [page]);

    const handleChangePage = (event, newPage) => {
        onPageChange(newPage);
    };

    return (
        <>
            {contentList.length > 0 ? (
                <div className="bulkdeleter-modal-table-container">
                    {/* Fixed Header */}
                    <div className="bulkdeleter-modal-table-fixed-header">
                        <TableContainer>
                            <Table className="table-bulkDeleter-list">
                                <TableHead className="bulkdeleter-modal-table-header">
                                    <TableRow>
                                        <TableCell className="bulkdeleter-modal-table-id-cell">ID</TableCell>
                                        <TableCell />
                                        <TableCell className="bulkdeleter-modal-table-filename-cell">파일명</TableCell>
                                        <TableCell className="bulkdeleter-modal-table-playtime-cell">재생 시간</TableCell>
                                        <TableCell>생성 날짜</TableCell>
                                        <TableCell>수정 날짜</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>

                    {/* Scrollable Content */}
                    <div className="bulkdeleter-modal-table-scrollable-content" ref={tableContainerRef}>
                        <TableContainer>
                            <Table className="table-bulkDeleter-list">
                                <TableBody>
                                    {isLoading ? (
                                        <TableRow>
                                            <TableCell id="tableCell-loading" colSpan={6} align="center">
                                                <LoadingComponent />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        contentList.map((row) => (
                                            <TableRow key={row.id}>
                                                <TableCell className="bulkdeleter-modal-table-id-cell">{row.id}</TableCell>
                                                <TableCell className="tc-content-list-thumbnail">
                                                    <div className='img-content-list-thumnail'>
                                                        <img onError={(e) => { e.target.style.display = 'none'; }} src={cdn ? `${cdn}/${row.uuid}/thumbnail/tn_1.png` : ''}></img>
                                                    </div>
                                                </TableCell>
                                                <TableCell className="bulkdeleter-modal-table-filename-cell">{row.realFileName}</TableCell>
                                                <TableCell>{row.playTime.toFixed(2)}</TableCell>
                                                <TableCell>{new Date(row.createdAt).toLocaleString('ko-KR')}</TableCell>
                                                <TableCell>{new Date(row.updatedAt).toLocaleString('ko-KR')}</TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    {/* Fixed Pagination */}
                    <div className="bulkdeleter-modal-pagination-container">
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handleChangePage}
                            color="primary"
                            showFirstButton
                            showLastButton
                        />
                    </div>
                </div>
            ) : !noData ? (
                <LoadingComponent />
            ) : (
                <div className="bulkdeleter-modal-no-content-container">
                    콘텐츠가 없습니다.
                </div>
            )}
        </>
    );
}

export default BulkDeleterModalTable;